import { format } from 'date-fns';

const formatDate = (date: Date | string, formatter = 'dd.MM.yyyy') => {
  return format(new Date(date), formatter);
};
const formatDay = (date: Date | string, formatter = 'dd.MM') => {
  return format(new Date(date), formatter);
};

const formatTime = (date: Date | string, formatter = 'HH.mm') => formatDate(date, formatter);
const formatDateTime = (date: Date | string, formatter = 'dd.MM.yyyy HH.mm') => formatDate(date, formatter);

export default {
  formatDay,
  formatDate,
  formatTime,
  formatDateTime,
};
